import { Box, BoxProps } from "@chakra-ui/layout";
import React from "react";

export const Card = (props: BoxProps) => {
  return <Box padding="2" {...props} />;
};
